import {
  BuildingExperienceEnum,
  BuildingExperiencePrimaryServiceType,
  User,
  USER_STATUS
} from '../types/User';

export const isStandaloneFutureResident = (user: User | null | undefined) =>
  !!user &&
  user.presentation?.presentationType === BuildingExperienceEnum.Standalone &&
  user.status === USER_STATUS.APPLICANT;

// primary-service destination for a standalone building's CURRENT residents
export const getStandalonePrimaryServicePath = (user: User) => {
  switch (user.presentation.primaryServiceTypeId) {
    case BuildingExperiencePrimaryServiceType.Amenities:
      return `/lease/${user.propertyUnitLeaseId}/amenities`;
    case BuildingExperiencePrimaryServiceType.LivlyEvents:
      return `/lease/${user.propertyUnitLeaseId}/events`;
    case BuildingExperiencePrimaryServiceType.BuildingOffers:
      return `/lease/${user.propertyUnitLeaseId}/marketplace`;
    default:
      return `/lease/${user.propertyUnitLeaseId}/my-lease`;
  }
};

// future/applicant residents in a standalone building always land on Building Offers,
// regardless of the building's configured primaryServiceTypeId (mirrors Android's
// OnboardingActivity -> standalone_onboarding_nav_graph, which starts at the Marketplace
// screen unconditionally; see ZOMBIE-3193/ZOMBIE-3194)
export const getStandaloneFutureResidentPath = (user: User) =>
  `/lease/${user.propertyUnitLeaseId}/marketplace`;
